// src/Components/MissionVision/MissionVision.jsx
import React from "react";
import { motion } from "framer-motion";
import { FaBullseye, FaEye, FaHandsHelping, FaUsers, FaStar } from "react-icons/fa";
import "./MissionVision.css";

const MissionVision = () => {
  return (
    <section className="mission-vision-section">
      <motion.h1
        className="mv-heading"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Mission & Vision
      </motion.h1>

      {/* Mission & Vision Row */}
      <div className="mv-row">
        {/* Mission */}
        <motion.div
          className="mv-card"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="mv-icon">
            <FaBullseye size={40} color="var(--ug-gold)" />
          </div>
          <div className="mv-content">
            <h2>Mission Statement</h2>
            <ul>
               UGAAL is dedicated to fostering a strong sense of community among its members by providing valuable networking opportunities and creating an inclusive environment that encourages personal connections and lasting friendships. Our mission is to unite the Association into a cohesive fellowship, enhancing the social and economic well-being of all members. We aim to establish a supportive platform for Liberians residing abroad, including current and former University of Ghana attendees, to connect with peers back in Liberia and build meaningful relationships.
            </ul>
          </div>
        </motion.div>

        {/* Vision */}
        <motion.div
          className="mv-card"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="mv-icon">
            <FaEye size={40} color="var(--ug-gold)" />
          </div>
          <div className="mv-content">
            <h2>Vision Statement</h2>
            <p>
              UGAAL is driven by a vision that aligns seamlessly with the mission and overarching goals of the University of Ghana. Our vision is clear and compelling: to inspire excellence and positively influence society through the provision of  high-quality service. This commitment reflects our dedication to fostering a culture of innovation, integrity, and impactful services that resonates across the university and the broader community.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Core Values */}
      <motion.div
        className="mv-card core-values-card"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className="mv-icon">
          <FaStar size={40} color="var(--ug-gold)" />
        </div>
        <div className="mv-content">
          <h2>Core Values</h2>
          <ul className="core-values">
            <li><FaUsers /> Community Building and Networking</li>
            <li><FaHandsHelping /> Professional Development and Support</li>
            <li><FaHandsHelping /> Financial Support and Advocacy</li>
            <li><FaStar /> Cultural Engagement and Social Events</li>
          </ul>
        </div>
      </motion.div>
    </section>
  );
};

export default MissionVision;
